import {ErrorModel} from '../../models';
import {DAO_CODE} from './_daoCode';
import axios from 'axios';
import {URL} from '../root';
const FUNCTION_CODE = 'GET_ALL_TRAINING_ATTACHMENTS';

export async function getAllTrainingAttachments(
    userData: Record<string, any>,
    params: string
) {
    try {
        const response = await axios.get(
            `${URL}/training-attachements/?page_size=2000${params}`,
            {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Token ${userData.userToken}`
                }
            },
        );

        return response.data;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${DAO_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la récupération de la liste des pièces jointes',
            error: error
        });
    }
}
